import styled, { ThemeProvider } from "styled-components";

import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { styledTheme } from "theme/mainTheme";
import grecoTriangleBg from "../../assets/GrECoGraphicTriangles.svg";

export function FallbackSpinner() {
  return (
    <Container>
      <FluentProvider theme={webLightTheme}>
        <ThemeProvider theme={styledTheme}>
          {" "}
          <Container>
            <Content>
              <div className="loader"></div>
            </Content>{" "}
          </Container>
        </ThemeProvider>
      </FluentProvider>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  max-width: 100%;

  .loader {
    width: 40px;
    height: 40px;
    border: 4px solid ${({ theme }) => theme.palette?.neutralLight || "#eaeaea"};
    border-top: 4px solid
      ${({ theme }) => theme.palette?.themePrimary || "#0078d4"};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
